import styled from "styled-components"

export const SvgIcon = styled.svg`
    :hover {
        color: ${({hoverColor})=> hoverColor}
    }
`